<template>
  <b-form inline>
    <label class="sr-only" for="search-input"> {{ $t("common.search") }}</label>

    <b-input-group id="fieldset-horizontal" class="col-md-7">
      <b-button class="mr-3 esep-blue-bg" variant="primary" @click="emitSearch" :disabled="this.searchString.length < 3">
        {{ $t('common.search') }}
      </b-button>
      <b-input-group-prepend is-text>
        <b-icon icon="search"></b-icon>
      </b-input-group-prepend>
      <b-input id="search-input" :placeholder="$t('roleManagement.searchBar')" v-model="searchString"></b-input>
    </b-input-group>

  </b-form>
</template>
<script>

export default {
  name: "role-management-search",
  data() {
    return {
      searchString: "",
    };
  },
  methods: {
    emitSearch() {
      this.$emit("search-string-changed", this.searchString);
    }
  },
};
</script>